<template>
    <div class="message-item__content--swiper-img-text">
        <div class="swiper-img-text">
            <swiper :options="swiperOptions">
                <swiper-slide
                    class="swiper__item"
                    v-for="(item, index) in swiperList"
                    :key="index">
                    <div class="swiper__inner">
                        <div class="swiper__header"
                            @click="clickHeader(item.data)">
                            <div class="swiper__cover"
                                :style="{
                                    'background-image': `url(${item.image})`
                                }"></div>
                            <div class="swiper__info" :style="{'--color': color}">
                                <div class="swiper__title">
                                    <span>{{item.name}}</span>
                                    <i class="type__icon icon_link"
                                        v-if="item.data.type === 'url'"></i>
                                </div>
                                <div class="swiper__desc">{{item.desc}}</div>
                            </div>
                        </div>
                        <div class="option__list" v-if="item.options.length > 0">
                            <div class="option__item"
                                v-for="(option, index) in item.options"
                                :key="index"
                                :style="{'--color': color}"
                                @click="clickItem(option)">
                                <div class="option__name">{{option.text}}</div>
                                <span class="option__icon icon_arrow-right"></span>
                            </div>
                        </div>
                    </div>
                </swiper-slide>
                <div class="swiper-button-prev" slot="button-prev"
                    v-show="swiperList.length > 1">
                    <span class="navigation__icon icon_arrow-right"></span>
                </div>
                <div class="swiper-button-next" slot="button-next"
                    v-show="swiperList.length > 1">
                    <span class="navigation__icon icon_arrow-right"></span>
                </div>
            </swiper>
        </div>
    </div>
</template>

<script>
    import { sendMessage } from '@/utils/message_send'
    import { MESSAGE_NAME } from '@/constants/message'

    export default {
        name: 'MessageContentSwiperImgText',
        props: {
            swiperList: {
                type: Array,
                required: true
            }
        },
        data () {
            return {
                swiperOptions: {
                    observer: true,
                    observeParents: true,
                    slidesPerView: 'auto',
                    spaceBetween: 5,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        disabledClass: 'swiper-button-disabled'
                    }
                }
            }
        },
        computed: {
            isDesktop () {
                return this.$eventBus.isDesktop
            },
            theme () {
                return this.$eventBus.theme
            },
            color () {
                if (this.theme === 'white') {
                    return this.$store.state.theme.color
                }
                return this.$store.state.lingkeColor
            }
        },
        methods: {
            clickHeader ({ type, text, url }) {
                if (type === 'text') {
                    sendMessage({
                        type: 'base',
                        detailType: MESSAGE_NAME.TEXT,
                        content: text
                    })
                } else if (type === 'url') {
                    window.location.href = url
                }
            },
            clickItem ({ text }) {
                sendMessage({
                    type: 'base',
                    detailType: MESSAGE_NAME.TEXT,
                    content: text
                })
                this.$eventBus.$emit('showinputstatus', {is_input:true})
            },
            initSwiperOptions () {
                if (this.isDesktop) {
                    this.swiperOptions.spaceBetween = 10
                }
            }
        },
        created () {
            this.initSwiperOptions()
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../css/option_list.scss";

    .swiper-container {
        /deep/ .swiper-button {
            &-prev, &-next {
                width: 26px;
                height: 80px;
            }

            &-prev {
                left: 15px;
            }
            &-next {
                right: 15px;
            }
        }
    }

    .swiper {
        &__item {
            width: 245px;

            @include desktop {
                width: 560px;
            }
        }

        &__inner {
            width: 100%;
            overflow: hidden;
            font-size: 14px;
            color: $primary-text-color;
            background-color: #FFFFFF;
            box-shadow: $primary-box-shadow;
            @include radius(.5);
        }

        &__info {
            padding: 10px 15px;

            position: relative;

            &::before {
                content: '';
                display: block;
                width: 2px;
                height: 14px;
                position: absolute;
                left: 0;
                top: 13px;
                // background: #5682F8;
                // background-color: var(--color);
                border-radius: 0 62px 62px 0;
            }
        }

        &__cover {
            height: 137px;
            background: 50% 50% no-repeat;
            background-size: cover;
            background-color: #FAFBFD;

            @include desktop {
                background-size: contain;
            }
        }

        &__title {
            display: flex;
            align-items: center;
            font-size: 14px;
            color: $primary-text-color;
            font-weight: 600;
            line-height: 20px;
            
            & > span {
                display: inline-block;
                @include text-line;
            }

            .type__icon {
                width: 14px;
                height: 14px;
                @include flex-center;
                display: inline-flex;
                border-radius: 50%;
                font-size: 10px;
                line-height: 1;
                color: #919294;
                background: #F3F4F6;
                margin-left: 5px;
                padding-top: 2px;
                padding-right: 2px;

                @include desktop {
                    padding-top: 1px;
                    padding-right: 1px;
                }

                &::before {
                    transform: scale(.8); // 10x10px
                    
                }
            }
        }

        &__desc {
            font-size: 12px;
            color: #919294;
            line-height: 16px;
            margin-top: 2px;
            @include text-line(2);
        }
    }

    .option {
        &__list {
            border-top: 1px solid #E1E2E4;
        }

    }
</style>
